export enum ObjectType {
    MODEL = "MODEL",
    ELEMENT = "ELEMENT",
    RELATIONSHIP = "RELATIONSHIP",
    PROPERTY_DEFINITION = "PROPERTY_DEFINITION",
    DIAGRAM = "DIAGRAM",
    NODE = "NODE",
    CONNECTION = "CONNECTION",
    ORGANIZATION_ITEM = "ORGANIZATION_ITEM",
}